export default function Footer() {
  return (
    <footer id="footer" className="bg-background-800 text-background-100 pt-14 md:pt-20 pb-6">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <a href="#hero" className="inline-block mb-4 cursor-pointer">
              <span className="text-xl font-bold font-heading text-background-50 tracking-wide">
                51<span className="text-primary-400">吃瓜</span>官网
              </span>
            </a>
            <p className="text-sm text-background-400 leading-relaxed">
              51吃瓜官网（51吃瓜网）是全网最受欢迎的吃瓜资讯聚合平台。每日更新全网最新吃瓜资源，一站式浏览51吃瓜网今日吃瓜内容——图文、视频、爆料全覆盖。做最好的51吃瓜群众聚集地，让每一天都有新瓜吃。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-100 mb-4">快速导航</h4>
            <nav className="flex flex-col gap-2">
              <a href="#updates" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">今日吃瓜更新</a>
              <a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">吃瓜专题索引</a>
              <a href="#ranking" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">吃瓜热度榜单</a>
              <a href="#media" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">视频吃瓜</a>
              <a href="#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">常见问答</a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-100 mb-4">吃瓜专题</h4>
            <nav className="flex flex-col gap-2">
              <a href="#carousel" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">焦点吃瓜专题</a>
              <a href="#cards" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">热门吃瓜卡片</a>
              <a href="#topics" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">热门话题标签</a>
              <a href="#comments" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">瓜友热评</a>
              <a href="#contact" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">投稿爆料</a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-100 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500 leading-relaxed">
              更多合作伙伴即将上线，敬请期待。
            </p>
            <div className="mt-4">
              <h4 className="text-sm font-bold text-background-100 mb-2">联系我们</h4>
              <p className="text-sm text-background-400">投稿/合作：通过本站投稿表单提交</p>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 51吃瓜官网 · 51吃瓜网今日吃瓜 · 全网最新吃瓜资源合集 · 每日吃瓜精选
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500">关注我们</span>
            <a href="#footer" className="text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
              <i className="ri-weibo-line text-lg w-5 h-5 flex items-center justify-center"></i>
            </a>
            <a href="#footer" className="text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
              <i className="ri-wechat-line text-lg w-5 h-5 flex items-center justify-center"></i>
            </a>
            <a href="#footer" className="text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
              <i className="ri-vidicon-line text-lg w-5 h-5 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}